// extracted by mini-css-extract-plugin
var _1 = "PdfViewerNavigation-moduleinputPagination__AKvR3 PdfViewerPageInput-modulePdfViewerPageInput__uO_bG";
export { _1 as "inputPagination" }
